function Ctrl($scope, $uibModalInstance) {
  $uibModalInstance.dismiss('cancel');
}

Ctrl.$inject = [
  '$scope',
  '$uibModalInstance'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/services/modal/earnCredit/earnCreditModalCtrl.js